module.exports = __webpack_public_path__ + "1ab35a97179ba8c78d9b02716dd62d8b.pdf";